<template>
  <div class="default-template">
    <div class="default-template__ttl">{{ question.question }}</div>
    <div class="default-template__sub-ttl"></div>
    <div class="main__action">
      <a
        class="btn"
        target="_blank"
        download
        href="../Elevated_Education_by_Lev_Grzhonko.pdf"
        >Download Ebook</a
      >
    </div>
  </div>
</template>
<script>
export default {
  name: "QuestionTemplate",
  props: {
    question: Object,
    answers: Object,
  },
  data() {
    return {};
  },
  watch: {},
  methods: {},
};
</script>
